const currency = {
    "afn": { "name": "Afghan Afghani", "symbol": "؋" },
    "all": { "name": "Albanian Lek", "symbol": "L" },
    "dzd": { "name": "Algerian Dinar", "symbol": "د.ج" },
    "aoa": { "name": "Angolan Kwanza", "symbol": "Kz" },
    "ars": { "name": "Argentine Peso", "symbol": "$" },
    "amd": { "name": "Armenian Dram", "symbol": "֏" },
    "awg": { "name": "Aruban Florin", "symbol": "ƒ" },
    "aud": { "name": "Australian Dollar", "symbol": "$" },
    "azn": { "name": "Azerbaijani Manat", "symbol": "₼" },
    "bsd": { "name": "Bahamian Dollar", "symbol": "$" },
    "bhd": { "name": "Bahraini Dinar", "symbol": ".د.ب" },
    "bdt": { "name": "Bangladeshi Taka", "symbol": "৳" },
    "bbd": { "name": "Barbadian Dollar", "symbol": "$" },
    "byn": { "name": "Belarusian Ruble", "symbol": "Br" },
    "bzd": { "name": "Belize Dollar", "symbol": "BZ$" },
    "bmd": { "name": "Bermudan Dollar", "symbol": "$" },
    "btn": { "name": "Bhutanese Ngultrum", "symbol": "Nu." },
    "bob": { "name": "Bolivian Boliviano", "symbol": "Bs." },
    "bam": { "name": "Bosnia-Herzegovina Convertible Mark", "symbol": "KM" },
    "bwp": { "name": "Botswanan Pula", "symbol": "P" },
    "brl": { "name": "Brazilian Real", "symbol": "R$" },
    "gbp": { "name": "British Pound Sterling", "symbol": "£" },
    "bnd": { "name": "Brunei Dollar", "symbol": "$" },
    "bgn": { "name": "Bulgarian Lev", "symbol": "лв" },
    "bif": { "name": "Burundian Franc", "symbol": "FBu" },
    "khr": { "name": "Cambodian Riel", "symbol": "៛" },
    "cad": { "name": "Canadian Dollar", "symbol": "$" },
    "cvd": { "name": "Cape Verdean Escudo", "symbol": "$" },
    "kyd": { "name": "Cayman Islands Dollar", "symbol": "$" },
    "xaf": { "name": "Central African CFA Franc", "symbol": "FCFA" },
    "xof": { "name": "West African CFA Franc", "symbol": "CFA" },
    "clp": { "name": "Chilean Peso", "symbol": "$" },
    "cny": { "name": "Chinese Yuan", "symbol": "¥" },
    "cop": { "name": "Colombian Peso", "symbol": "$" },
    "kmf": { "name": "Comorian Franc", "symbol": "CF" },
    "cdf": { "name": "Congolese Franc", "symbol": "FC" },
    "crc": { "name": "Costa Rican Colón", "symbol": "₡" },
    "hrk": { "name": "Croatian Kuna", "symbol": "kn" },
    "cup": { "name": "Cuban Peso", "symbol": "₱" },
    "czk": { "name": "Czech Koruna", "symbol": "Kč" },
    "dkk": { "name": "Danish Krone", "symbol": "kr" },
    "djf": { "name": "Djiboutian Franc", "symbol": "Fdj" },
    "dop": { "name": "Dominican Peso", "symbol": "RD$" },
    "xcd": { "name": "East Caribbean Dollar", "symbol": "$" },
    "egp": { "name": "Egyptian Pound", "symbol": "£" },
    "ern": { "name": "Eritrean Nakfa", "symbol": "Nfk" },
    "etb": { "name": "Ethiopian Birr", "symbol": "Br" },
    "eur": { "name": "Euro", "symbol": "€" },
    "fkp": { "name": "Falkland Islands Pound", "symbol": "£" },
    "fjd": { "name": "Fijian Dollar", "symbol": "$" },
    "gmd": { "name": "Gambian Dalasi", "symbol": "D" },
    "gel": { "name": "Georgian Lari", "symbol": "₾" },
    "ghs": { "name": "Ghanaian Cedi", "symbol": "₵" },
    "gip": { "name": "Gibraltar Pound", "symbol": "£" },
    "gtq": { "name": "Guatemalan Quetzal", "symbol": "Q" },
    "ggp": { "name": "Guernsey Pound", "symbol": "£" },
    "gnf": { "name": "Guinean Franc", "symbol": "FG" },
    "gyd": { "name": "Guyanaese Dollar", "symbol": "$" },
    "htg": { "name": "Haitian Gourde", "symbol": "G" },
    "hnl": { "name": "Honduran Lempira", "symbol": "L" },
    "hkd": { "name": "Hong Kong Dollar", "symbol": "$" },
    "huf": { "name": "Hungarian Forint", "symbol": "Ft" },
    "isk": { "name": "Icelandic Króna", "symbol": "kr" },
    "inr": { "name": "Indian Rupee", "symbol": "₹" },
    "idr": { "name": "Indonesian Rupiah", "symbol": "Rp" },
    "irr": { "name": "Iranian Rial", "symbol": "﷼" },
    "iqd": { "name": "Iraqi Dinar", "symbol": "ع.د" },
    "ils": { "name": "Israeli New Shekel", "symbol": "₪" },
    "jmd": { "name": "Jamaican Dollar", "symbol": "J$" },
    "jpy": { "name": "Japanese Yen", "symbol": "¥" },
    "jep": { "name": "Jersey Pound", "symbol": "£" },
    "jod": { "name": "Jordanian Dinar", "symbol": "د.ا" },
    "kzt": { "name": "Kazakhstani Tenge", "symbol": "₸" },
    "kes": { "name": "Kenyan Shilling", "symbol": "KSh" },
    "kwd": { "name": "Kuwaiti Dinar", "symbol": "د.ك" },
    "kgs": { "name": "Kyrgystani Som", "symbol": "с" },
    "lak": { "name": "Laotian Kip", "symbol": "₭" },
    "lbp": { "name": "Lebanese Pound", "symbol": "ل.ل" },
    "lsl": { "name": "Lesotho Loti", "symbol": "L" },
    "lrd": { "name": "Liberian Dollar", "symbol": "$" },
    "lyd": { "name": "Libyan Dinar", "symbol": "ل.د" },
    "mop": { "name": "Macanese Pataca", "symbol": "MOP$" },
    "mkd": { "name": "Macedonian Denar", "symbol": "ден" },
    "mga": { "name": "Malagasy Ariary", "symbol": "Ar" },
    "mwk": { "name": "Malawian Kwacha", "symbol": "MK" },
    "myr": { "name": "Malaysian Ringgit", "symbol": "RM" },
    "mvr": { "name": "Maldivian Rufiyaa", "symbol": ".ރ" },
    "imp": { "name": "Manx pound", "symbol": "£" },
    "mru": { "name": "Mauritanian Ouguiya", "symbol": "UM" },
    "mur": { "name": "Mauritian Rupee", "symbol": "₨" },
    "mxn": { "name": "Mexican Peso", "symbol": "$" },
    "mdl": { "name": "Moldovan Leu", "symbol": "L" },
    "mnt": { "name": "Mongolian Tugrik", "symbol": "₮" },
    "mad": { "name": "Moroccan Dirham", "symbol": "د.م." },
    "mzn": { "name": "Mozambican Metical", "symbol": "MT" },
    "mmk": { "name": "Myanmar Kyat", "symbol": "Ks" },
    "nad": { "name": "Namibian Dollar", "symbol": "$" },
    "npr": { "name": "Nepalese Rupee", "symbol": "₨" },
    "ang": { "name": "Netherlands Antillean Guilder", "symbol": "ƒ" },
    "twd": { "name": "New Taiwan Dollar", "symbol": "NT$" },
    "nzd": { "name": "New Zealand Dollar", "symbol": "$" },
    "nio": { "name": "Nicaraguan Córdoba", "symbol": "C$" },
    "ngn": { "name": "Nigerian Naira", "symbol": "₦" },
    "kpw": { "name": "North Korean Won", "symbol": "₩" },
    "nok": { "name": "Norwegian Krone", "symbol": "kr" },
    "omr": { "name": "Omani Rial", "symbol": "ر.ع." },
    "pkr": { "name": "Pakistani Rupee", "symbol": "₨" },
    "pab": { "name": "Panamanian Balboa", "symbol": "B/." },
    "pgk": { "name": "Papua New Guinean Kina", "symbol": "K" },
    "pyg": { "name": "Paraguayan Guarani", "symbol": "₲" },
    "pen": { "name": "Peruvian Sol", "symbol": "S/" },
    "php": { "name": "Philippine Peso", "symbol": "₱" },
    "pln": { "name": "Polish Złoty", "symbol": "zł" },
    "qar": { "name": "Qatari Rial", "symbol": "ر.ق" },
    "ron": { "name": "Romanian Leu", "symbol": "lei" },
    "rub": { "name": "Russian Ruble", "symbol": "₽" },
    "rwf": { "name": "Rwandan Franc", "symbol": "FRw" },
    "shp": { "name": "Saint Helena Pound", "symbol": "£" },
    "wst": { "name": "Samoan Tala", "symbol": "T" },
    "stn": { "name": "São Tomé and Príncipe Dobra", "symbol": "Db" },
    "sar": { "name": "Saudi Riyal", "symbol": "﷼" },
    "rsd": { "name": "Serbian Dinar", "symbol": "дин." },
    "scr": { "name": "Seychellois Rupee", "symbol": "₨" },
    "sll": { "name": "Sierra Leonean Leone", "symbol": "Le" },
    "sgd": { "name": "Singapore Dollar", "symbol": "$" },
    "sbd": { "name": "Solomon Islands Dollar", "symbol": "$" },
    "sos": { "name": "Somali Shilling", "symbol": "S" },
    "zar": { "name": "South African Rand", "symbol": "R" },
    "krw": { "name": "South Korean Won", "symbol": "₩" },
    "ssp": { "name": "South Sudanese Pound", "symbol": "£" },
    "lkr": { "name": "Sri Lankan Rupee", "symbol": "₨" },
    "sdg": { "name": "Sudanese Pound", "symbol": "ج.س." },
    "srd": { "name": "Surinamese Dollar", "symbol": "$" },
    "szl": { "name": "Swazi Lilangeni", "symbol": "L" },
    "sek": { "name": "Swedish Krona", "symbol": "kr" },
    "chf": { "name": "Swiss Franc", "symbol": "CHF" },
    "syp": { "name": "Syrian Pound", "symbol": "£" },
    "tjs": { "name": "Tajikistani Somoni", "symbol": "ЅМ" },
    "tzs": { "name": "Tanzanian Shilling", "symbol": "TSh" },
    "thb": { "name": "Thai Baht", "symbol": "฿" },
    "top": { "name": "Tongan Paʻanga", "symbol": "T$" },
    "ttd": { "name": "Trinidad and Tobago Dollar", "symbol": "TT$" },
    "tnd": { "name": "Tunisian Dinar", "symbol": "د.ت" },
    "try": { "name": "Turkish Lira", "symbol": "₺" },
    "tmt": { "name": "Turkmenistani Manat", "symbol": "m" },
    "ugx": { "name": "Ugandan Shilling", "symbol": "USh" },
    "uah": { "name": "Ukrainian Hryvnia", "symbol": "₴" },
    "aed": { "name": "United Arab Emirates Dirham", "symbol": "د.إ" },
    "usd": { "name": "United States Dollar", "symbol": "$" },
    "uyu": { "name": "Uruguayan Peso", "symbol": "$U" },
    "uzs": { "name": "Uzbekistan Som", "symbol": "so'm" },
    "vuv": { "name": "Vanuatu Vatu", "symbol": "VT" },
    "ves": { "name": "Venezuelan Bolívar", "symbol": "Bs." },
    "vnd": { "name": "Vietnamese Dong", "symbol": "₫" },
    "yer": { "name": "Yemeni Rial", "symbol": "﷼" },
    "zmw": { "name": "Zambian Kwacha", "symbol": "ZK" },
    "zwl": { "name": "Zimbabwean Dollar", "symbol": "Z$" }
  }
  
  const currenciesData = Object.entries(currency).map(([code, details]) => ({
    code: code.toUpperCase(),
    name: details.name,
    symbol: details.symbol
  }));
  
  // Sort alphabetically by code
  currenciesData.sort((a, b) => a.code.localeCompare(b.code));
  
  export default currenciesData;